var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('oie-base-button',{attrs:{"css-classes":"button--with-border button--green skulist__actions-right","text":_vm.tStatic('cartAddSkuListToCart'),"disabled":_vm.products.length === 0},on:{"click":_vm.addListToCart}})}
var staticRenderFns = []

export { render, staticRenderFns }